import {CommonService} from './common.service';
import {HttpClient} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {BehaviorSubject, Observable} from 'rxjs';
import {Socket} from 'ngx-socket-io';

@Injectable({
  providedIn: 'root'
})

export class EventLogsService {
  private serviceModel: string;
  public updatedEventLogs: Observable<any>;
  eventSubject: BehaviorSubject<number>;
  public totalEvents: number;


  constructor(private commonService: CommonService,
              private httpClient: HttpClient,
              private socket: Socket) {
    this.updatedEventLogs = this.socket.fromEvent<any>('updateEventLog');
    this.serviceModel = 'event_log';
    this.eventSubject = new BehaviorSubject<number>(0);
    this.getEventLogsCount().then(data => {
      this.totalEvents = data[0].count;
      this.setInitialEventNumber(this.totalEvents);
    });
  }

  setInitialEventNumber(notifications: number): void {
  this.eventSubject.next(notifications);
  }

  raiseEventNumber(): void {
    this.totalEvents++;
    this.eventSubject.next(this.totalEvents);
  }

  decreaseEventNumber(): void {
    this.totalEvents--;
    this.eventSubject.next(this.totalEvents);
  }

  observe(): Observable<number> {
    return this.eventSubject.asObservable();
  }

  public getEventLogs(model: string, modelID: number): Promise<any> {
    return new Promise((resolve) => {
      this.httpClient.get(`${this.serviceModel}?filter=model = '${model}' AND model_id = ${modelID} AND is_done_value=0 AND is_visible = 1`)
        .subscribe((eventLogs: any[]) => {
          if (eventLogs.length > 0) {
            this.commonService.updateObject('event_log', eventLogs).then(() => {
              resolve(eventLogs);
            });
          } else {
            resolve(eventLogs);
          }
        });
    });
  }

  public getRefrigeratorEventLogs(model: string, modelID: number): Promise<any> {
    return new Promise((resolve) => {
      this.httpClient.get(`event_log/refrigerator?filter=model='${model}' AND model_id=${modelID} AND is_done_value=0 AND is_visible = 1`)
        .subscribe((eventLogs: any[]) => {
          if (eventLogs.length > 0) {
            this.commonService.updateObject('event_log', eventLogs).then(() => {
              resolve(eventLogs);
            });
          } else {
            resolve(eventLogs);
          }
        });
    });
  }

  public getSalePointEventLogs(modelID: number): Promise<any> {
    return new Promise((resolve) => {
      this.httpClient.get(`event_log/sale_point?filter=model_id = ${modelID} AND is_done_value=0 AND is_visible = 1`)
        .subscribe((eventLogs: any[]) => {
          if (eventLogs.length > 0) {
            this.commonService.updateObject('event_log', eventLogs).then(() => {
              resolve(eventLogs);
            });
          } else {
            resolve(eventLogs);
          }
        });
    });
  }

  public getAgreementEventLogs(modelID: number): Promise<any> {
    return new Promise((resolve) => {
      this.httpClient.get(`event_log/agreement?filter=agreement_id = ${modelID} AND is_done_value=0 AND is_visible = 1`)
        .subscribe((eventLogs: any[]) => {
          if (eventLogs.length > 0) {
            this.commonService.updateObject('event_log', eventLogs).then(() => {
              resolve(eventLogs);
            });
          } else {
            resolve(eventLogs);
          }
        });
    });
  }

  public getSingleEventLog(id: number): Promise<any> {
    return new Promise((resolve) => {
      this.httpClient.get(`event_log/sale_point?filter=id = ${id} AND is_done_value=0 AND is_visible = 1`)
        .subscribe((eventLogs: any[]) => {
          if (eventLogs.length > 0) {
            this.commonService.updateObject('event_log', eventLogs).then(() => {
              resolve(eventLogs);
            });
          } else {
            resolve(eventLogs);
          }
        });
    });
  }

  public getEventLogsCount(): Promise<any> {
    return new Promise((resolve) => {
      this.httpClient.get(`${this.serviceModel}?filter=is_displayed_value = 0 AND is_visible = 1&select=COUNT(*) AS count`)
        .subscribe((result) => {
          resolve(result);
        });
    });
  }
}
